export default {
    type: 'date',
    format: {},
    default: {
        logic: 'min',
        period: 'day'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'rolling'],
        period: ['day', 'week', 'month', 'year']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Date Played',
        category: ['User', 'Plays'],
        description: 'Date of when the game was played.',
        summarise: {
            prefix: 'Played'
        },
        unit: function(rule) {

            return rule.setting.period

        }
    },
    rules: {
        linked: [],
        legacy: ['played.range','playe.sometime','played.first','played.last','played.context']
    }
}